// extracted by mini-css-extract-plugin
export default {"wrapper":"Calendar_wrapper__DeV36","legend":"Calendar_legend__w4nuL","legendEntry":"Calendar_legendEntry__CXxvc","legendColor":"Calendar_legendColor__SKB+W"};